/**
 * @generated SignedSource<<a9445143f3c241f3515fec056462fc86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "resetPasswordRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88febe19ed208f3255dd5d59e1e9ad41",
    "id": null,
    "metadata": {},
    "name": "ResetPasswordRequestMutation",
    "operationKind": "mutation",
    "text": "mutation ResetPasswordRequestMutation(\n  $email: String!\n) {\n  resetPasswordRequest(email: $email) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "093d95a42c358016b2817a93b31a46cd";

export default node;
